module.exports = __webpack_public_path__ + "static/media/dummy-logo.bb35698b.svg";